export const removeUndefinedValFromObject = (obj: object): object => {
  try {
    const newObj = { ...obj };
    return JSON.parse(JSON.stringify(newObj));
  } catch {
    return obj;
  }
};
